export default __webpack_public_path__ + "static/media/ic_wavax_40.ba36eda4.svg";